const NOT_FEEDBACK = '未反馈'
const FEEDBACK_MODIFIABLE = '已反馈（可修改）'
const FEEDBACK_NON_MODIFIABLE = '已反馈（不可修改）'

export { NOT_FEEDBACK, FEEDBACK_MODIFIABLE, FEEDBACK_NON_MODIFIABLE }
